import { createWidget } from '@typeform/embed';

const updateEventComponentStatus = (event, status) => {
  const eventStatus = event.querySelector('.event-component_status');
  const eventCTA = event.querySelector('.event-component_cta .btn_text');

  let cta = 'View event';
  eventStatus.classList.remove('status-chip--open');

  if(status == 'Open') {
    cta = 'Sign up';
    eventStatus.classList.add('status-chip--open');
  } else if(status == 'Full') {
    cta = 'Join the waitlist';
  }

  eventStatus.innerHTML = status;
  eventCTA.innerHTML = cta;
};

const updateEventStatus = (event, status) => {
  let eventCTA = event.querySelector('.btn--primary .btn_text');

  let cta = 'Join the waitlist';

  if(status == 'Open') {
    cta = 'Sign up';
  }

  eventCTA.innerHTML = cta;
};

const showTypeform = (typeformId, email) => {
  let container = document.querySelector('.typeform-embed');

  createWidget(typeformId, {
    container: container,
    hideHeaders: true,
    hideFooter: true,
    opacity: 0,
    autoResize: true,
    hidden: {
      email: email
    }
  });

  document.querySelector('[data-modal-target="modal-login"]').style.display = 'none';
  document.querySelector('.typeform-embed').style.display = 'block';
}

const initEvents = () => {
  document.querySelectorAll('.event-component[data-signup-form]').forEach((event) => {
    let signupFormID = event.getAttribute('data-signup-form');
    let waitlistFormID = event.getAttribute('data-waitlist-form');

    let status = 'Save the date';

    if(signupFormID !== '') {
      let formHolder = document.createElement('div');
      formHolder.classList.add('typeform-holder');
      document.body.appendChild(formHolder);

      createWidget(signupFormID, {
        container: formHolder,
        onReady: ({ isClosed }) => {
          if(!isClosed) {
            status = 'Open';
          } else if(waitlistFormID !== '') {
            status = 'Full';
          } else {
            status = 'Closed';
          }

          updateEventComponentStatus(event, status);
        }
      });
    } else {
      if(waitlistFormID !== '') {
        status = 'Full';
      }

      updateEventComponentStatus(event, status);
    }
  });

  document.querySelectorAll('.event-signup').forEach((event) => {
    let signupFormID = event.getAttribute('data-signup-form');
    let waitlistFormID = event.getAttribute('data-waitlist-form');

    let status = 'Open';

    if(signupFormID !== '') {
      let formHolder = document.createElement('div');
      formHolder.classList.add('typeform-holder');
      document.body.appendChild(formHolder);

      createWidget(signupFormID, {
        container: formHolder,
        onReady: ({ isClosed }) => {
          if(!isClosed) {
            status = 'Open';
          } else if(waitlistFormID !== '') {
            status = 'Full';
          }

          updateEventStatus(event, status);
          event.classList.add('ready');
        }
      });
    } else {
      if(waitlistFormID !== '') {
        status = 'Full';
      }

      updateEventStatus(event, status);
      event.classList.add('ready');
    }

    let memberEmail = sessionStorage.getItem('memberEmail');
    if(memberEmail) {
      if(status == 'Open') {
        showTypeform(signupFormID, memberEmail);
      } else {
        showTypeform(waitlistFormID, memberEmail);
      }
    }

    let form = document.querySelector('.app-login');
    form.onsubmit = async (e) => {
      e.preventDefault();

      let errorMessage = form.querySelector('.app-login_error');
      errorMessage.style.display = 'none';

      form.classList.add('submitting');

      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      const email = form.querySelector('input[name="email"]').value;
      const url = `https://us-central1-arnolds-pump-club.cloudfunctions.net/newsletter?action=getSubscriptionStatus`;

      const data = {
        email: email
      };

      var requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
      };

      const result = await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => result)
      .catch((error) => console.log('error', error));

      form.classList.remove('submitting');

      if(result.state === 'active') {
        document.querySelector('[data-modal-name="modal-login"] [data-modal-close]').click();
        sessionStorage.setItem('memberEmail', email);

        if(status == 'Open') {
          showTypeform(signupFormID, memberEmail);
        } else {
          showTypeform(waitlistFormID, memberEmail);
        }
      } else {
        errorMessage.style.display = 'flex';
      }
    };
  });
};
export { initEvents };